export const IMAGES = {
  logo: require("../assets/wendt-logo.png"),
};
const Constants = {
  IMAGES,
};
export default Constants;
